<template>
<div>

    <vm-card list :header="__('economy') + ' - ' + customer.name" collapsable :collapsed="collapsed" @collapse="collapsed = !collapsed">
        <template v-slot:actions>
            <vm-collapse-action :collapsed="collapsed" />
        </template>

        <vm-row>
            <vm-group c4>
                <vm-label :text="__('deposits_expected')" />
                <vm-input maxbo bold disabled
                    v-model="economy.depositsExpected.display"
                    :valid="economy.depositsExpected.check"
                    :invalid="!economy.depositsExpected.check" />
            </vm-group>
            <vm-group c4>
                <vm-label :text="__('avg_profit')" />
                <vm-input maxbo bold disabled
                    v-model="economy.avgProfit.display"
                    :valid="economy.avgProfit.check"
                    :invalid="!economy.avgProfit.check" />
            </vm-group>
            <vm-group c4>
                <vm-label :text="__('credit_limit')" />
                <vm-input maxbo bold disabled
                    v-model="economy.creditLimit.display"
                    :valid="economy.creditLimit.check"
                    :invalid="!economy.creditLimit.check" />
            </vm-group>
        </vm-row>

        <vm-row>
            <vm-group c4>
                <vm-label :text="__('deposits_this_year')" />
                <vm-input maxbo bold disabled
                    v-model="economy.depositsThisYear.display"
                    :valid="economy.depositsThisYear.check"
                    :invalid="!economy.depositsThisYear.check" />
            </vm-group>
            <vm-group c4 />
            <vm-group c4>
                <vm-label :text="__('credit_remaining')" />
                <vm-input maxbo bold disabled
                    v-model="economy.creditRemaining.display"
                    :valid="economy.creditRemaining.check"
                    :invalid="!economy.creditRemaining.check" />
            </vm-group>
        </vm-row>

        <vm-row>
            <vm-group c4>
                <vm-label :text="__('deposits_estimated')" />
                <vm-input maxbo bold disabled
                    v-model="economy.depositsEstimated.display"
                    :valid="economy.depositsEstimated.check"
                    :invalid="!economy.depositsEstimated.check" />
            </vm-group>
        </vm-row>

    </vm-card>

</div>
</template>
<script>
import nformat from '../nformat';

export default {
name: 'Economy',
props: {
    customer: {
        type: Object,
        default: null
    }
},
data() {
    return {
        collapsed: false,
        economy: {
            avgProfit: {
                value: 0,
                display: 'NA',
                check: false
            },
            creditLimit: {
                value: 0,
                display: 'NA',
                check: false
            },
            creditRemaining: {
                value: 0,
                display: 'NA',
                check: false
            },
            depositsExpected: {
                value: 0,
                display: 'NA',
                check: false
            },
            depositsThisYear: {
                value: 0,
                display: 'NA',
                check: false
            },
            depositsEstimated: {
                value: 0,
                display: 'NA',
                check: false
            }
        }
    }
},
methods: {
    calculateEconomy() {
        this.economy.avgProfit.value = Number(this.customer.economy.avgProfit);
        this.economy.creditLimit.value = Number(this.customer.economy.creditLimit);
        this.economy.creditRemaining.value = Number(this.customer.economy.creditRemaining);
        this.economy.depositsThisYear.value = Number(this.customer.economy.depositsThisYear);
        if (this.customer.economy.depositsExpected.includes('>5 mill')) {
            this.economy.depositsExpected.value = 5000000;
        }else if (this.customer.economy.depositsExpected.includes('2-5 mill')) {
            this.economy.depositsExpected.value = 2000000;
        }else if (this.customer.economy.depositsExpected.includes('0,5-2,0 mill')) {
            this.economy.depositsExpected.value = 500000;
        }else {
            this.economy.depositsExpected.value = 250000;
        }
        var today = new Date();
        const dayOfYear = (Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()) - Date.UTC(today.getFullYear(), 0, 0)) / 24 / 60 / 60 / 1000;
        this.economy.depositsEstimated.value = (this.economy.depositsThisYear.value / dayOfYear) * 340;
        this.economy.depositsEstimated.display = nformat.formatMoney(this.economy.depositsEstimated.value);
        this.economy.depositsEstimated.check = !(this.economy.depositsEstimated.value < this.economy.depositsExpected.value);

        this.economy.depositsExpected.check = true;
        this.economy.depositsThisYear.check = true;
        this.economy.creditLimit.check = true;

        let lowestCredit = (this.economy.creditLimit.value * 15) / 100;
        if (this.economy.creditRemaining.value < lowestCredit) {
            this.economy.creditRemaining.check = false;
        }else {
            this.economy.creditRemaining.check = true;
        }

        if (this.economy.avgProfit.value < 15 && this.economy.avgProfit.value != 0) {
            this.economy.avgProfit.check = false;
        }else {
            this.economy.avgProfit.check = true;
        }

        this.economy.avgProfit.display = this.customer.economy.avgProfit + ' %';
        this.economy.depositsExpected.display = this.customer.economy.depositsExpected;
        this.economy.creditLimit.display = nformat.formatMoney(Number(this.customer.economy.creditLimit));
        this.economy.creditRemaining.display = nformat.formatMoney(Number(this.customer.economy.creditRemaining));
        this.economy.depositsThisYear.display = nformat.formatMoney(Number(this.customer.economy.depositsThisYear));
    }
},
mounted() {
    this.calculateEconomy();
}
}
</script>
<style scoped>

</style>
